import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Api } from "../app-api";
import { CategoryTime, Program } from "./models/register-models";

const divRoot: HTMLDivElement = document.querySelector("#ko-waitlist");
const divModel: HTMLDivElement = document.querySelector("#divRegisterWaitListModel");

export class Allocation {
    camp: number;
    categoryTime: CategoryTime;
    dates: string;
    full: boolean;
    location: string;
    price: string;
    program: Program;
    skillCategory: number;
    skillLevels: SkillLevel[];
    spaces: number;

    addTemplate: string = "add-template";
    programHtml: string;
    skillLevelsText: string;

    qty = ko.observable(0);

    add: () => void;
    minus: () => void;

    constructor(data: any, root: ViewModel) {
        let self = this;

        self.camp = data.camp;
        self.categoryTime = new CategoryTime(data.categoryTime);
        self.dates = data.dates;
        self.full = data.full;
        self.location = root.waitlist.location;
        self.price = data.price;
        self.program = new Program(root.waitlist.program);
        self.skillCategory = data.skillCategory;
        self.skillLevels = _(root.waitlist.skillLevels).map(x => new SkillLevel(x));
        //self.spaces = data.spaces;
        self.spaces = 1;

        if (self.full) {
            self.addTemplate = "full-template";
        }

        self.programHtml = "<span class='aspect-name " + self.program.textCss + "'>" + self.program.name + "</span>";

        self.skillLevelsText = _.chain(self.skillLevels)
            .sortBy(x => x.sort)
            .pluck("name")
            .value()
            .join(", ");

        self.add = () => {
            var qty = self.qty() + 1;
            self.qty(Math.min(qty, self.spaces));
        }

        self.minus = () => {
            var qty = self.qty() - 1;
            self.qty(Math.max(0, qty));
        }
    }

    public toJson() {
        let self = this;

        return {
            camp: self.camp,
            categoryTime: self.categoryTime.id,
            skillCategory: {
                id: self.skillCategory,
                skillLevels: _(self.skillLevels)
                    .map(y => y.id)
            }
        }
    }
}

export class SkillLevel {
    id: number;
    name: string;
    sort: number;

    constructor(data: any) {
        let self = this;

        self.id = data.id;
        self.name = data.name;
        self.sort = data.sort;
    }
}

export class ViewModel {
    id: string;
    waitlist: any;

    busy = ko.observable(false);

    allocation = ko.observable<Allocation>();

    enableNext: ko.PureComputed<boolean>;
    full: ko.PureComputed<boolean>;

    next: () => void;
    remove: () => void;

    constructor(model: any) {
        let self = this;

        let data = JSON.parse(model);

        self.id = data.id;
        self.waitlist = data;

        self.enableNext = ko.pureComputed(() => {
            return self.allocation() ? self.allocation().qty() > 0 : false;
        }, self);
        
        self.full = ko.pureComputed(() => {
            return self.allocation() ? self.allocation().full : true;
        }, self);

        self.busy.subscribe(newVal => App.busy(newVal));

        self.next = () => {
            if (!self.busy() && self.validate())
                self.register();
        }

        self.remove = () => {
            if (!self.busy())
                App.alertInfo('Remove: ' + self.id);
        }

        self.searchCamps();
    }

    private validate(): boolean {
        let self = this;

        if (self.allocation() && self.allocation().qty() > 0)
            return true;

        App.alertWarning("Please select the number of spaces desired.");
        return false;
    }

    private register() {
        let self = this;

        self.busy(true);

        let data = {
            registrations: [
                {
                    allocation: self.allocation().toJson(),
                    qty: self.allocation().qty(),
                    waitlist: self.id
                }],
            waitlist: self.id
        };

        Api.Register(data)
            .done(results => {
                if (results.error) { App.alertError(results.message); return; }
                window.location.href = results.nextUrl;
            })
            .always(() => self.busy(false));
    }

    private searchCamps() {
        let self = this;

        self.busy(true);

        let data = {
            waitlist: self.id
        }

        Api.SearchCamps(data)
            .done(results => {
                if (Api.NoResults("No Search Camps Results", results)) { return; }

                self.allocation(new Allocation(results.allocations[0], self));
            })
            .always(() => self.busy(false));
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(divModel.textContent), divRoot);
    }
}

$(document).ready(() => init());